<template>
  <div>
    <!-- 弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogFormVisible"
      @close="handleClose"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="新密码" label-width="80px" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            auto-complete="off"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { postModifyPassword } from "@/network/login.js";

export default {
  name: "OaVueModifyPasswordDialog",

  data() {
    return {
      dialogFormVisible: false,
      form: {
        password: "",
      },
      rules: {
        password: [
          { required: true, message: '请输入密码！', trigger: "blur" },
        ],
      },
    };
  },

  watch: {
    "$store.state.showDialog"(newValue) {
      this.dialogFormVisible = newValue;
    },
  },

  mounted() {},

  methods: {
    handleModifyPassword() {
      this.dialogFormVisible = true;
    },
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$notify({
            type: "info",
            message: "修改中...",
          });
          postModifyPassword(
            this.$store.state.userInfo.userId,
            this.form.password
          )
            .then((res) => {
              if ((res.code === 0)) {
                this.$notify.success({ message: "修改成功！ 请重新登陆！" });
                this.$store.commit("tokenInvalid");
              } else {
                this.$notify.info({ message: res.msg });
              }
            })
            .catch((err) => {
              this.$notify.error({ message: err });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.passWord = "";
      this.$store.state.showDialog = false;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/modify-password-dialog.vue